<template>
  <div>
    <topbar
      :titulo="$t('ACADEMICO.FORMULARIO_ADITIVO')"
      :subtitulo="$t('ACADEMICO.FORMULARIO_ADITIVO_TURMA_DESCRICAO')"
      :breadcrumbs="breadcrumbs"
    >
      <template #header>
        <div class="d-flex flex-column flex-md-row justify-content-between align-items-md-center gap-2 ml-md-4">
          <b-button
            variant="secondary"
            class="mr-2"
            @click="retornarParaAditivos"
          >
            {{ $t('GERAL.VOLTAR') }}
          </b-button>
        </div>
      </template>
    </topbar>

    <b-tabs v-model="tabIndex" card>
      <b-tab :title="`1 - ${$t('ACADEMICO.CONTRATOS_TURMA')}`">
        <contrato-turma :form="form" :filtro="filtro"/>
      </b-tab>
      <b-tab :title="`2 - ${$t('ACADEMICO.DADOS_GERAIS_DO_ADITIVO')}`" lazy>
        <contratos-dados-gerais :form="form"/>
      </b-tab>
      <b-tab :title="`3 - ${$t('ACADEMICO.PRECOS')}`" lazy>
        <contrato-precos :form="form" :filtro="filtro"/>
      </b-tab>
      <b-tab :title="`4 - ${$t('ACADEMICO.DESCONTOS')}`" lazy>
        <div>
          <contrato-desconto :form="form" />
          <div class="d-flex justify-content-end">
            <b-button variant="primary" @click="salvarAditivo()">{{
              $t('ACADEMICO.SALVAR_ADITIVO')
            }}</b-button>
          </div>
        </div>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import { START_LOADING, STOP_LOADING } from '@/store/Store';
import mensagem from '@/common/utils/mensagem';
import helpers from '@/common/utils/helpers';

import ContratosService from '@/common/services/contratos/contratos.service';

import Topbar from '@/layouts/full-layout/horizontal-sidebar/Topbar.vue';
import ContratoTurma from './components/ContratoTurma.vue';
import ContratosDadosGerais from './components/ContratosDadosGerais.vue';
import ContratoPrecos from './components/ContratoPrecos.vue';
import ContratoDesconto from './components/ContratoDesconto.vue';

export default {
  name: 'FormularioCriarAditivo',

  props: {
    exibir: { type: Boolean, default: false },
  },

  components: {
    Topbar,
    ContratoTurma,
    ContratosDadosGerais,
    ContratoPrecos,
    ContratoDesconto
  },

  data() {
    return {
      filtro: {
        anoLetivoId: '',
        cursoId: '',
        grupoTurmaId: '',
        turmaId: '',
      },
      opcoes: {
        tipoAditivos: [],
        contratos: [],
        turma: '',
      },
      form: {
        contratos: [],
        tipoAditivoContrato: '',
        precos: [],
        descontos: [],
        motivo: '',
        dataGeracao: new Date(),
      },
   
      tabIndex: 0,
      breadcrumbs: [
        { titulo: this.$t('ACADEMICO_HOME.PAINEL_ACADEMICO') },
        { titulo: this.$t('ACADEMICO.ADITIVOS_DE_CONTRATO') },
        { titulo: this.$t('ACADEMICO.FORMULARIO_ADITIVO') },
      ],
    };
  },
  methods: {
    salvarAditivo() {
      if (!this.validarFormulario() || this.form.contratos.length === 0)
        return mensagem.warning(
          this.$t('GERAL.AVISO'),
          this.$t('ACADEMICO.PREENCHA_OS_CAMPOS_OBRIGATORIOS')
        );

      const descontosId = this.form.descontos.map((desconto) => desconto.id);
      const novoAditivo = { ...this.form, descontos: descontosId };
      
      this.$store.dispatch(START_LOADING);

      ContratosService.adicionarAditivoContratos(novoAditivo)
        .then(({ data }) => {
          mensagem.sucesso(this.$t('GERAL.SUCESSO'), this.$t(data.mensagem));
          this.form = {
            contratos: [],
            tipoAditivoContrato: '',
            precos: [],
            descontos: [],
            motivo: '',
            dataGeracao: new Date(),
          };
          this.limparFiltro();
          this.retornarParaAditivos();
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },

    retornarParaAditivos() {
      this.$router.push({
        name: 'aditivos',
        params: { id: this.$route.params?.id }
      })
    },

    validarFormulario() {
      return helpers.validarFormulario(this.$refs);
    },

    limparFiltro() {
      this.opcoes.turma = '';
      this.opcoes.contratos = [];
    },
  },
};
</script>
